import { render } from "./Sessions-list.vue?vue&type=template&id=dc4575b0&scoped=true"
import script from "./Sessions-list.vue?vue&type=script&lang=js"
export * from "./Sessions-list.vue?vue&type=script&lang=js"

import "./Sessions-list.vue?vue&type=style&index=0&id=dc4575b0&scoped=true&lang=css"
import "./Sessions-list.vue?vue&type=style&index=1&id=dc4575b0&lang=css"

import exportComponent from "/codebuild/output/src1910356388/src/ilongevity-backoffice/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc4575b0"]])

export default __exports__